import React from "react";

// License to Love — dual-figure mark shaped like a seal
export function Logo({ size = 30, className = "", variant = "ink" }) {
  const text = variant === "cream" ? "#F2EBD8" : "#0E1214";
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`} data-testid="wholesome-logo">
      <svg viewBox="0 0 72 72" width={size} height={size} aria-hidden>
        <defs>
          <linearGradient id="wg-amber" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#E4C79B" />
            <stop offset="1" stopColor="#A46D3E" />
          </linearGradient>
        </defs>
        <circle cx="36" cy="36" r="32" fill="none" stroke="url(#wg-amber)" strokeWidth="2" strokeDasharray="3 3" />
        <path d="M28 22c4 0 7 3 8 6 1-3 4-6 8-6 5 0 8 4 8 8 0 3-2 6-4 8L36 52 24 38c-2-2-4-5-4-8 0-4 3-8 8-8z"
              fill="url(#wg-amber)" />
      </svg>
      <div className="flex flex-col leading-none">
        <span style={{ fontFamily: "Fraunces, serif", fontSize: size * 0.72, color: text, letterSpacing: "-0.02em" }}>wholesome</span>
        <span style={{ fontFamily: "Instrument Sans, sans-serif", fontSize: size * 0.26, color: variant === "cream" ? "#D4A574" : "#A46D3E", letterSpacing: "0.24em", textTransform: "uppercase", marginTop: 2 }}>License to Love</span>
      </div>
    </div>
  );
}
export default Logo;
